// extracted by mini-css-extract-plugin
export default {"heading":"DeliveryDate-module__heading___elBnt","isDelayed":"DeliveryDate-module__isDelayed___BeF8Z","isDelivered":"DeliveryDate-module__isDelivered___ayYCg"};